module.exports = __webpack_public_path__ + "static/media/7ICJ2.6e554286.jpg";